<template>
    <div class="inner-container">
        <div class="section-title budget"><i class="icon icon-calculator-coins"></i><span>Бюджет</span></div>
        <div class="section-subtitle"><i class="icon icon-grid"></i><span>{{ $t("app.links.budget_requests") }}<budget-forms-list :curFormSelect="'/form01-123'"/></span>
            <forms-download-reprt
                :progress="progress"
                :isReportUploading="isReportUploading"
                :form="form"
                :guListLen="guListLen"
                :header="header"
                :isParentGuExist="isParentGuExist"
                :isHeadGu="isHeadGu"
                :hasDeltaRep="true"
                @checkSignatories="checkSignatories"
                @downloadRep="downloadRep"
                @downloadDeltaRep="downloadDeltaRep"
                @downloadBatchReports="downloadBatchReports"
            ></forms-download-reprt>
        </div>
        <div class="filter-container">
            <div class="left-content">
            </div>
            <div class="right-content">
                <c-budget-forms-data-transfer
                    v-if="!isGkkpMode && !(progress < 100) && variantAttribute"
                    :header="header"
                    :lng="lng"
                    :getDataTransferText="getDataTransferText"
                    :getErrText="getErrText"
                    :makeToast="makeToast"
                    @reloadTable="loadDatas"
                />
                <div class="filter-actions filter-actions-flex">
                    <c-budget-forms-copy-data 
                        v-if="!(progress < 100) && variantAttribute && (header.year < header.cur_year + 2)"
                        :budgetForm="budgetForm"
                        :header="header"
                        :isLoad="isLoad"
                        @keyPress="keyPress"
                    />
                    <b-button :style="{ 'minWidth': '110px' }" variant="primary" @click="addItem" v-if="variantAttribute" :disabled="isLoad || !lastRowFilled"><i class="icon icon-plus-circle"></i> {{ getCommonText('add') }}</b-button>
                    <b-button :style="{ 'minWidth': '110px' }" variant="success" @click="prepareForSave" :disabled="isLoad || !variantAttribute || load || !isDirty || budgetForm.length === 0">{{ getCommonText('save') }}</b-button>
                </div>
            </div>
        </div>

        <div class="table-container">
            <b-overlay :show="mainTableOverlay" rounded="sm">
            <b-table
                :fields="tableFields"
                :items="budgetForm"
                responsive="true"
                bordered
                head-variant="light"
                sticky-header="true"
                no-border-collapse
            >
                <template #top-row="data">
                    <td class="td-numbering"></td>
                    <td class="td-numbering table-success">1</td>
                    <td class="td-numbering table-danger">2</td>
                    <td class="td-numbering table-info">3</td>
                    <td class="td-numbering table-primary">4</td>
                    <td class="td-numbering table-warning">5</td>
                    <td class="td-numbering table-success">6</td>
                    <td class="td-numbering table-danger">7</td>
                    <td class="td-numbering"></td>
                </template>
                <template #thead-top="data">
                   
                    <b-tr>
                        <b-th colspan="4" class="text-center"></b-th>
                        <b-th colspan="2" class="text-center">{{ getFormText('size') }}</b-th>
                        <b-th colspan="3" class="text-center"></b-th>
                    </b-tr>
                </template>
                <template #head(action)>
                    <div class="text-center">
                        <b-form-checkbox 
                            v-model="selectAll" 
                            @change="e => setIsAllDelete(e)"
                            :value="true"
                            :unchecked-value="false" />
                    </div>
                </template>
                <template #head(more)>
                    <div class="text-center">
                        <i 
                            :title="getCommonText('del_selected')"
                            class="icon icon-close table-all-remove"
                            @click="deleteItem(`${selectAll ? getCommonText('clear_all') : getCommonText('clear')}`)"/>
                    </div>
                </template>
                <template #cell(action)="data">
                    <b-form-checkbox
                        v-model="data.item.itemToDelete"
                        @input="e => { if (!e) selectAll = false; }"
                        :value="true"
                        :unchecked-value="false" />
                </template>
                <template #cell(order_number)="data">
                    {{ data.index + 1 }}
                </template>
                <template #cell(party_name)="data">
                    <div :class="{ 'error': variantAttribute && !data.item.political_parties }">
                        <multiselect v-if="variantAttribute"
                            :value="getPartyObject(data.item.political_parties)"
                            :options="getPartiesOptionsForRow(data.item.political_parties)"
                            :custom-label="partyLabel"
                            track-by="code"
                            :placeholder="getFormText('party_name_placeholder')"
                            :searchable="true"
                            :allow-empty="false"
                            :show-labels="false"
                            @input="party => { data.item.political_parties = party ? party.code : null; }"
                        />
                        <div v-else>{{ getPoliticalPartyName(data.item.political_parties) }}</div>
                        <template v-if="variantAttribute && !data.item.political_parties">
                            <p class="goods-form-val-msg">{{ getCommonText('must_be_filled') }}</p>
                        </template>
                    </div>
                </template>
                <template #cell(votes_count)="data">
                    <div :class="{ 'error': variantAttribute && data.item.political_parties && !(parseInt(data.item.votes_count) > 0) }">
                        <b-form-input v-if="variantAttribute"
                                      class="text-right"
                                      :value="data.item.votes_count"
                                      :disabled="!data.item.political_parties"
                                      @change="v => data.item.votes_count = v"
                                      @keyup.enter.exact="keyup13"
                                      @keypress="keyPress($event, '^\\d+$')"
                                      @blur="inputFixedVldtn(data.item, 'votes_count', data.item.votes_count, 0)">
                        </b-form-input>
                        <div v-else>{{ data.value }}</div>
                        <template v-if="variantAttribute && data.item.political_parties && !(parseInt(data.item.votes_count) > 0)">
                            <p class="goods-form-val-msg">{{ getCommonText('positive') }}</p>
                        </template>
                    </div>
                </template>
                <template #cell(mrp)>
                    <div class="text-right">{{ $n(mrp) }}</div>
                </template>
                <template #cell(coefficient)="data">
                    <div :class="{ 'error': variantAttribute && data.item.political_parties && !(parseFloat(data.item.coefficient) > 0) }">
                        <b-form-input v-if="variantAttribute"
                                      class="text-right"
                                      :value="data.item.coefficient"
                                      :disabled="!data.item.political_parties"
                                      @change="v => data.item.coefficient = v"
                                      @keyup.enter.exact="keyup13"
                                      @keypress="keyPress($event, '^\\d*\\.?\\d{0,2}$')"
                                      @blur="inputFixedVldtn(data.item, 'coefficient', data.item.coefficient, 2)">
                        </b-form-input>
                        <div v-else>{{ data.value }}</div>
                        <template v-if="variantAttribute && data.item.political_parties && !(parseFloat(data.item.coefficient) > 0)">
                            <p class="goods-form-val-msg">{{ getCommonText('positive') }}</p>
                        </template>
                    </div>
                </template>
                <template #cell(total_expense)="data">
                    <div class="text-right">
                        {{ $n(data.item.total) }}
                    </div>
                </template>
                
                <template #cell(files)="data">
                    <span
                        class="blue pointer underline"
                        @click="onFilesClick(data.item)"
                    >({{data.item.files}})</span>
                </template>
                <template #cell(more)="data">
                    <div class="text-center">
                        <i 
                            :title="getCommonText('clear_rec')" 
                            class="icon icon-clear table-remove" 
                            v-if="variantAttribute" 
                            @click="deleteItem(`${getCommonText('clear_rec')}`, data.item, data.index)"
                        ></i>
                    </div>
                </template>

                <template #bottom-row>
                    <td class="text-right" colspan="3">{{ getCommonText('total') }}</td>
                    <td class="text-right">{{ $n(totalVotesCount) }}</td>
                    <td colspan="2"></td>
                    <td class="text-right">{{ $n(total) }}</td>
                    <td colspan="2"></td>
                </template>
            </b-table>
            </b-overlay>
        </div>
        <div class="table-add" v-if="variantAttribute" :disabled="isLoad || !lastRowFilled">
            <span @click="addItem" :class="{ 'disabled-link': !lastRowFilled }"><i class="icon icon-plus-circle"></i> {{ getCommonText('add') }}</span>
        </div>
        <files-updown v-if="isFilterReady" 
                      :header="header"
                      :variant-attribute="variantAttribute"
                      :variant-name="variantName ? variantName['pure_name_' + lng] : ''"
                      :load="load"
                      @getFiles="getFiles"
                      @getNewFiles="getNewFiles($event)"
                      @delFile="delFile($event)"
                      @onFilePreview="onFilePreview"
                      ref="fileUpdown"
        ></files-updown>
        <modal-files-management-nodecode
            ref="modalFilesManagement"
            :variant-attribute="variantAttribute"
            @triggDownloadFile="triggDownloadFile"
            @triggDownloadAllFiles="triggDownloadAllFiles"
            @fileUpload="fileUpload"
            @toggleIsAdd="toggleIsAdd($event)"
            />
    </div>
</template>

<script>
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import FilesUpdown from '@/modules/budget-request/FilesUpdown';
import BudgetFormsList from '@/modules/budget-request/components/budget-forms-list.vue';
import ModalFilesManagementNodecode from './components/modal-files-management-nodecode.vue';
import CBudgetFormsCopyData from './components/budget-forms-copy-data.vue';
import FormsHandlerMixin1 from "./mixins/forms-handler-mixin-1";
import FormsDownloadReprt from "./components/forms-download-reprt.vue";
import CBudgetFormsDataTransfer from './components/budget-forms-data-transfer.vue';

export default {
    name: 'Form01-166',
    components: { 
        FilesUpdown, 
        BudgetFormsList, 
        FormsDownloadReprt, 
        ModalFilesManagementNodecode, 
        CBudgetFormsCopyData,
        CBudgetFormsDataTransfer
    },
    mixins: [FormsHandlerMixin1],
    created() {
        this.$emit("setForm", this.form);
    },
    async mounted() {
        this.progress = 15;
    },
    watch: {
        openDisabled() {
            this.$emit("setOpenDisabled", this.openDisabled);
        },
        progress() {
            this.$emit("setProgress", this.progress);
        },
        budgetForm: {
            deep: true,
            handler() {
                this.isDirty = true;
            }
        }
    },
    data() {
        return {
            form: {
                code: '01-166',
                name_kk: '',
                name_ru: 'Расчет расходов на оплату выборов и деятельность политических партий'
            },
            variantAttribute: null,
            variantName: null,
            budgetForm: [],
            header: null,
            files: null,
            load: true,
            openDisabled: false,
            mrp: 0,
            dictPoliticalParties: [],
            isLoad: false,
            isDirty: false,
            row_files: [],
            isAdd: false,
            rowId: false,
            newRowStartId: -1,
        };
    },
    methods: {
        addItem() {
            const item = { id: this.newRowStartId };
            this.newRowStartId--;
            this.itemUpdate(item);
            this.defineTotal(item);
            
            this.budgetForm.push(item);
        },
        
        async itemUpdate(item) {
            this.$set(item, 'political_parties', null);
            this.$set(item, 'votes_count', 0);
            this.$set(item, 'coefficient', 0);
            this.$set(item, 'itemToDelete', false);
            this.$set(item, 'files', 0);

            try {
                this.load = true;
                const response = await fetch(`/api-py/get-new-row-files-form/${item.id}/` + JSON.stringify(this.header));
                const emptyRowFiles = await response.json();
                this.$set(item, 'row_files', emptyRowFiles);
            } catch (error) {
                this.makeToast('danger', `${this.getErrText('bad_request')} itemUpdate`, error.toString());
            }
            this.load = false;
        },

        defineTotal(item) {
            Object.defineProperty(item, 'total', {
                get: () => {
                    const votesCount = this.safeDecimal(item.votes_count);
                    const coefficient = this.safeDecimal(item.coefficient);
                    const mrp = this.safeDecimal(this.mrp);
                    return votesCount.mul(coefficient).mul(mrp).div(1000).toDecimalPlaces(2).toNumber();
                }
            });
        },

        deleteItem(msg, row = false, index = false) {
            this.deleteItemWithAttachedFiles(msg, row, index);
        },

        getFiles(data) {
            this.files = data;
        },

        getPartyObject(code) {
            if (!code) return null;
            return this.dictPoliticalParties.find(p => p.code === code) || null;
        },

        partyLabel(party) {
            if (!party) return '';
            const nameKey = this.lng ? `name_${this.lng}` : 'name_ru';
            return party[nameKey] || party.name_ru || party.code;
        },

        getPartiesOptionsForRow(currentCode) {
            const otherSelected = this.budgetForm
                .map(item => item.political_parties)
                .filter(code => code && code !== currentCode);
            const nameKey = this.lng ? `name_${this.lng}` : 'name_ru';
            // backend orders by code ASC, end_date DESC NULLS FIRST —
            // первая is_actual-запись для каждого code уже является "лучшей"
            const seen = new Set();
            return this.dictPoliticalParties
                .filter(party => {
                    if (party.is_actual !== true) return false;
                    if (seen.has(party.code)) return false;
                    seen.add(party.code);
                    return true;
                })
                .sort((a, b) => (a[nameKey] || '').localeCompare(b[nameKey] || ''))
                .map(party => ({ ...party, $isDisabled: otherSelected.includes(party.code) }));
        },

        getPoliticalPartyName(code) {
            if (!code) return '';
            const parties = this.dictPoliticalParties.filter(p => p.code === code);
            if (!parties.length) return code;
            const party = parties.find(p => p.is_actual === true) || parties[0];
            const nameKey = this.lng ? `name_${this.lng}` : 'name_ru';
            return party[nameKey] || party.name_ru || code;
        },

        async loadPoliticalParties() {
            try {
                const response = await fetch(`/api-py/get_dict_political_parties/${this.header.variant_date_time}/`);
                this.dictPoliticalParties = await response.json();
            } catch (error) {
                this.makeToast('danger', `${this.getErrText('bad_request')} loadPoliticalParties()`, error.toString());
            }
        },

        async loadMrp() {
            this.mrp = 0;
            try {
                const response = await fetch(`/api-py/dictionary-normative-inds/${this.header.year}/${this.header.cur_year}/${this.header.variant_date_time}`);
                const items = await response.json();
                for (const row of items) {
                    if (row.code === 'MRP') {
                        this.mrp = parseFloat(row.value);
                        return;
                    }
                }
            } catch (error) {
                this.makeToast('danger', `${this.getErrText('bad_request')} loadDictNormativeInds`, error.toString());
            }
        },


        async loadDatas() {
            this.load = true;
            
            await Promise.all([this.loadPoliticalParties(), this.loadMrp()]);
            this.budgetForm.splice(0);
            let values = [];
            try {
                const response = await fetch('/api-py/get-budget-request-form-with-row-attach-files/' + JSON.stringify(this.header));
                values = await response.json();

                values.forEach(val => {
                    const item = {
                        id: val.id,
                        political_parties: val.political_parties,
                        votes_count: val.votes_count,
                        coefficient: val.coefficient,
                        files: val.files,
                        row_files: val.row_files,
                        itemToDelete: false
                    };
                    this.defineTotal(item);
                    this.budgetForm.push(item);
                });
            } catch (error) {
                this.makeToast('danger', `${this.getErrText('bad_request')} loadDatas`, error.toString());
            }
            this.load = false;
            this.$nextTick(() => { this.isDirty = false; });
        },

        isRowValid(row, rowNumber) {
            let valid = true;
            const prefix = `${this.getErrText('row')} ${rowNumber}. `;
            if (!row.political_parties) {
                this.makeToast('warning', this.getErrText('msg'), prefix + this.getErrText('cant_be_empty', { fieldName: this.getFormText('party_name') }));
                valid = false;
            }
            if (!row.votes_count || parseInt(row.votes_count) <= 0) {
                this.makeToast('warning', this.getErrText('msg'), prefix + this.getErrText('cant_be_zero', { fieldName: this.getFormText('votes_count') }));
                valid = false;
            }
            if (!row.coefficient || parseFloat(row.coefficient) <= 0) {
                this.makeToast('warning', this.getErrText('msg'), prefix + this.getErrText('cant_be_zero', { fieldName: this.getFormText('coefficient') }));
                valid = false;
            }
            return valid;
        },

        prepareForSave() {
            let hasError = false;
            let rowNumber = 1;
            for (const row of this.budgetForm) {
                if (!this.isRowValid(row, rowNumber)) hasError = true;
                rowNumber++;
            }
            if (hasError) return;

            const values = this.budgetForm.map(row => {
                const item = Object.assign({}, this.header);
                this.$set(item, 'id', row.id);
                this.$set(item, 'political_parties', row.political_parties);
                this.$set(item, 'votes_count', row.votes_count);
                this.$set(item, 'coefficient', row.coefficient);
                this.$set(item, 'row_files', row.row_files);
                return item;
            });

            if (values.length === 0) {
                this.makeToast('warning', this.getErrText('msg'), this.getErrText('not_saved'));
                return;
            }

            this.$bvModal.msgBoxConfirm(
                this.getCommonText('on_save'),
                {
                    title: this.getCommonText('confirm'),
                    size: 'lg',
                    buttonSize: 'sm',
                    okVariant: 'success',
                    okTitle: this.getCommonText('yes'),
                    cancelTitle: this.getCommonText('cancel'),
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(value => {
                    if (value && this.variantAttribute) {
                        this.save(values);
                    }
                })
                .catch(error => {
                    this.makeToast('danger', this.getErrText('saving_error'), error.toString());
                });
        },

        async save(values) {
            this.isLoad = true;
            try {
                const data = {
                    values,
                    header: this.header,
                };
                const response = await fetch('/api-py/save-brform01-166', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json;charset=utf-8'
                    },
                    body: JSON.stringify(data)
                });
                const result = await response.json();
                if ((response.status === 200) && (result.result === 'success')) {
                    if (this.files.length === 0) {
                        this.makeToast('warning', this.getErrText('warning'), this.getErrText('no_docs'));
                    }
                    this.selectAll = false;
                    this.makeToast('success', this.getErrText('msg'), this.getErrText('saved'));
                    this.deletingAgreementTotalResultHandler(result);
                    await this.loadDatas();
                } else {
                    this.selectAll = false;
                    await this.loadDatas();
                    throw this.getErrText('bad_data');
                }
            } catch (e) {
                this.makeToast('danger', this.getErrText('warning'), e.toString());
            } finally {
                this.isLoad = false;
            }
        },
    },
    computed: {
        total() {
            return this.totalCalculation(this.budgetForm, 'total');
        },

        lastRowFilled() {
            if (!this.budgetForm.length) return true;
            const last = this.budgetForm[this.budgetForm.length - 1];
            return !!last.political_parties
                && parseInt(last.votes_count) > 0
                && parseFloat(last.coefficient) > 0;
        },

        totalVotesCount() {
            return this.budgetForm.reduce((sum, item) => sum + (parseInt(item.votes_count) || 0), 0);
        },

        getFormText() {
            return this.setFormText('form_01_166.');
        },

        tableFields() {
            if (this.$i18n.locale) {
                return [
                    {
                        key: 'action',
                        label: ' '
                    },
                    {
                        key: 'order_number',
                        label: '№'
                    },
                    {
                        key: 'party_name',
                        label: this.getFormText('party_name'),
                        thStyle: 'min-width: 515px'
                    },
                    {
                        key: 'votes_count',
                        label: this.getFormText('votes_count')
                    },
                    {
                        key: 'mrp',
                        label: this.getFormText('mrp'),
                        thStyle: 'min-width: 100px'
                    },
                    {
                        key: 'coefficient',
                        label: this.getFormText('coefficient')
                    },
                    {
                        key: 'total_expense',
                        label: this.getFormText('total_expense'),
                        thStyle: 'max-width: 240px'
                    },
                    {
                        key: 'files',
                        label: this.getCommonText('files')
                    },
                    {
                        key: 'more',
                        label: ''
                    }
                ];
            };
            return [];
        },

    }
};
</script>
<style scoped>
    .filter-actions-flex {
        display: flex;
    }
    .goods-form-val-msg {
        font-size: 0.5rem;
        font-style: italic;
        color: red;
    }

    .disabled-link {
        opacity: 0.4;
        pointer-events: none;
        cursor: default;
    }

</style>